import React from "react";
import PropTypes from "prop-types";
import { BaasicModal, BaasicButton, BaasicDropdown } from 'core/components';
import { defaultTemplate } from "core/hoc";
import { Content } from "core/layouts";
import { observer } from "mobx-react";
import { FacilityOrderTemplateNewFlowInsuranceProductModal, FacilityOrderPatientNewFlowInsuranceNoteModal, FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal } from "application/facility-order-new-flow-insurance/components";
import { FacilityOrderPatientNewFlowInsuranceEditModal } from "application/facility-order-new-flow-us-intake/components";
import { FacilityOrderTemplateItemNewFlowActivatePatientModal, PatientInformationBarNewFlow } from "application/facility-order-new-flow/components";
import { DropDownButton, DropDownButtonItem, Button } from "@progress/kendo-react-buttons";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { toDate } from "core/utils";

const FacilityOrderTemplateNewFlowInsuranceEditTemplate = function ({ facilityOrderTemplateNewFlowInsuranceEditViewStore, disabled, disabledSendOrder }) {
	const {
		items,
		patient,
		isNewPatient,
		contentLoading,
		facilityOrderTemplateNewFlowInsuranceProductModal,
		isDisabledInactiveOption,
		showDropdownTableInactiveOptions,
		showTemplateNote,
		openFacilityOrderTemplateItemNewFlowActivatePatientModal,
		facilityOrderTemplateItemNewFlowActivatePatientModal,
		setNewFlowStatus,
		getSelectedInactiveOption,
		setSelectedInactiveOption,
		openFacilityOrderPatientNewFlowInsuranceNoteModal,
		facilityOrderPatientNewFlowInsuranceNoteModal,
		openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal,
		facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal,
		facilityOrderPatient,
		inactiveOptionStore,
		inactiveOptionStorId,
		isOrderVisible,
		changeOrderVisibility,
		openInsuranceInformation,
		selectedStatusAbrv,
		facilityOrderPatientNewFlowInsuranceEditModal,
		openFacilityOrderPatientNewFlowInsuranceEditModal,
		isMasterPatient,
		facilityOrder,
		disabledPatient
	} = facilityOrderTemplateNewFlowInsuranceEditViewStore;

	const handleDropDownItemsOnClick = async (e) => {
		if (e.item.text === "No changes") {
			setSelectedInactiveOption("no-change")
		}
		else if (e.item.text === "Change/Review") {
			setSelectedInactiveOption("change")
		}
	}

	return (
		items && items.length > 0 ?
			<div className="card--tertiary u-mar--bottom--sml--alt">
				<Content loading={contentLoading}>
					<ReactTooltip positionStrategy="fixed" id="registerTip" place="bottom" />
					<ReactTooltip positionStrategy="fixed" id="registerTipChangeReview" place="bottom" />
					<ReactTooltip positionStrategy="fixed" id="patientStatusBarTip" place="top" />
					<div className="card--tertiary__header">
						<div className="u-flex--default">
							<h4 className="card--tertiary__header__title">
								{patient && patient.lastName && `${patient.lastName}`}
								{patient && patient.lastName && patient.firstName && ', '}
								{patient && patient.firstName && `${patient.firstName}`}
							</h4>

							{/* <div className="card--tertiary__header__divider u-height--9"></div>
							<div className="u-icon u-icon--xsml u-icon--calendar u-mar--right--xsml"></div>
							<p className="type--tny type--color--opaque">{patient && toDate(patient.dateOfBirth)}</p>
							<div className="card--tertiary__header__divider u-height--9"></div>
							<div className="u-icon u-icon--xsml u-icon--user u-mar--right--xsml"></div>
							<p className="type--tny type--color--opaque">{patient && patient.ssn}</p> */}

                            <PatientInformationBarNewFlow patient={patient} role = "Insurance" isNewPatient={isNewPatient} isMasterPatient={isMasterPatient} disabled={disabledSendOrder} facilityOrder={facilityOrder}/>

							<div className="w--200--px u-mar--left--sml">
								<BaasicDropdown store={inactiveOptionStore} value={inactiveOptionStorId} onChange={(e) => { openFacilityOrderTemplateItemNewFlowActivatePatientModal(e.value.id, true) }} disabled={disabled || disabledPatient} />
							</div>
						</div>
						<div className="card--tertiary__header__actions u-mar--left--auto">

							{
								isNewPatient ?

										<div data-tooltip-content={isDisabledInactiveOption ? "These actions are enabled only for active patients" : ""} data-tooltip-id={isDisabledInactiveOption ? "registerTip" : ""}>
											<Button className="btn btn--base btn--light is-user" onClick={() => { openFacilityOrderPatientNewFlowInsuranceNoteModal("change") }} disabled={disabled || disabledPatient} data-tooltip-content="New Patient" data-tooltip-id="registerTip" />
										</div>
									:
									selectedStatusAbrv === "change" ?
										<Button className="btn btn--icon--sml status--sqare reload u-mar--left--tny btn--rounded" onClick={() => { openFacilityOrderPatientNewFlowInsuranceNoteModal() }} disabled={isDisabledInactiveOption || disabled || disabledPatient} data-tooltip-content="Change / Review Needed" data-tooltip-id="registerTip" />
										:
										showDropdownTableInactiveOptions ?
											<DropDownButton
												fillMode={"solid"}
												themeColor={"primary"}
												onItemClick={(e) => handleDropDownItemsOnClick(e)}
												buttonClass={`btn btn--base btn--ghost k-dropdown-button--icons status--sqare is-standalone ${getSelectedInactiveOption() === "reload--warning" ? "change" : "success"}`}
												disabled={disabled || disabledPatient}
												popupSettings={{
													animate: false,
													anchorAlign: { horizontal: "right", vertical: "bottom" },
													popupAlign: { horizontal: "right", vertical: "top" },
													popupClass: 'is-clean'
												}}
											>
												{(getSelectedInactiveOption("insurance") === "reload--warning" || (getSelectedInactiveOption("insurance") !== "success" && getSelectedInactiveOption("insurance") !== "reload--warning")) && <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--success" text="No changes" />}
												{(getSelectedInactiveOption("insurance") === "success" || (getSelectedInactiveOption("insurance") !== "success" && getSelectedInactiveOption("insurance") !== "reload--warning")) && <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--change" text="Change/Review" />}
											</DropDownButton>
											:
											selectedStatusAbrv !== "new-patient" &&
											<div className="status--sqare__wrapper" data-tooltip-content={isDisabledInactiveOption ? "These actions are enabled only for active patients" : ""} data-tooltip-id={isDisabledInactiveOption ? "registerTip" : ""}>
												<Button className="btn btn--icon--sml is-not-assigned u-radius--3 status--sqare reload" onClick={() => { openFacilityOrderPatientNewFlowInsuranceNoteModal("change") }} disabled={isDisabledInactiveOption || disabled || disabledPatient} data-tooltip-content="Change / Review Needed" data-tooltip-id="registerTipChangeReview" />
												<div data-tooltip-content={isNewPatient && !isDisabledInactiveOption ? "This action is disabled for new patients" : ""} data-tooltip-id={isNewPatient && !(isDisabledInactiveOption || disabled) ? "registerTip" : ""}>
													<Button className="btn btn--icon--sml is-not-assigned u-radius--3 status--sqare success" onClick={() => setNewFlowStatus("no-change")} disabled={isNewPatient || isDisabledInactiveOption || disabled || !facilityOrderPatient.eligibilityStatus || disabledPatient} data-tooltip-content="No Changes" data-tooltip-id="registerTip" />
												</div>
											</div>

							}
						</div>
					</div>
					<div className="card--tertiary__subheader" >
						<div className="u-flex--space-between">
							<div>
								<div className="u-flex u-flex--default u-mar--bottom--sml">
									<label className="type--color--opaque">Insurance Information </label>
									<BaasicButton
										className="btn btn--icon btn--icon--sml u-mar--left--tny"
										icon="u-icon u-icon--insurance-external-link u-icon--xmed"
										label=""
										disabled={disabledPatient}
										onlyIcon={true}
										onClick={() => openInsuranceInformation()} />
								</div>
								{patient &&
									<div className="card--tertiary__data">
										<div>
											<div className="card--tertiary__data__item">
												<div>Primary:</div>
												<div className="type--color--primary type--wgt--semibold">{patient.primaryInsurance}</div>
												{patient.primaryPolicyNo &&
													<div>{patient.primaryPolicyNo}</div>
												}
											</div>
											{patient.primaryInsurance !== "Medicare" && patient.inactiveMedicareNo &&
												<div className="card--tertiary__data__item">
													<div>Inactive:</div>
													<div className="type--color--primary type--wgt--semibold">Medicare</div>
													{patient.inactiveMedicareNo &&
														<div>{patient.inactiveMedicareNo}</div>
													}
												</div>
											}
										</div>
										<div>
											<div className="card--tertiary__data__item">
												<div>Secondary:</div>
												<div className="type--color--primary type--wgt--semibold">{patient.secondaryInsurance}</div>
												{patient.secondaryPolicyNo &&
													<div>{patient.secondaryPolicyNo}</div>
												}
											</div>
											{!patient.secondaryInsurance.includes("Medicaid") && patient.inactiveMedicaidNo &&
												<div className="card--tertiary__data__item">
													<div>Inactive:</div>
													<div className="type--color--primary type--wgt--semibold">Medicaid</div>
													{patient.inactiveMedicaidNo &&
														<div>{patient.inactiveMedicaidNo}</div>
													}
												</div>
											}
										</div>
										<BaasicButton
											className="btn btn--icon--sml btn--icon"
											icon="u-icon u-icon--sml u-icon--edit-alt"
											label=""
											onClick={() => openFacilityOrderPatientNewFlowInsuranceEditModal()}
											disabled={disabled || disabledPatient}
										/>
									</div>
								}
							</div>

							<div className="u-flex--default">
								{
									items.filter(fot => fot.isPriorAuthNeeded).length > 0 &&
									<BaasicButton
										type='button'
										className="btn btn--base-plus btn--light is-grey no-click u-mar--right--tny"
										label={`PAR ${items.filter(fot => fot.isPriorAuthNeeded).length}/${items.length}`}
									/>
								}

								<BaasicButton
									type='button'
									className="btn btn--base-plus btn--light btn--uppercase"
									label={facilityOrderPatient && facilityOrderPatient.eligibilityStatus ? facilityOrderPatient.eligibilityStatus.name : "Blank"}
									disabled={isDisabledInactiveOption || disabled || disabledPatient}
									onClick={() => { openFacilityOrderPatientNewFlowInsuranceNoteModal("change") }}
								/>
							</div>
						</div>
						{facilityOrderPatient.insuranceInfo &&
							<div className="u-flex u-flex--default w--100 u-mar--top--sml">
								<i className="u-icon u-icon--sml u-icon--add-note" />
								{facilityOrderPatient && <p>
									<span className="u-flex--grow--1 type--sml type--wgt--bold u-mar--left--tny">{facilityOrderPatient.insuranceInfo}</span>
								</p>}
							</div>
						}
						{(showTemplateNote || isNewPatient) && facilityOrderPatient &&
							<div className={`c-message has-input u-flex--default w--100 c-message--note--${isNewPatient ? "primary" : "orange"} u-mar--top--sml`}>
								<BaasicButton
									className="btn btn--icon"
									icon="u-icon u-icon--note--alt u-icon--sml"
									label=""
									onlyIcon={true}
									onClick={() => openFacilityOrderPatientNewFlowInsuranceNoteModal()}
									disabled={disabled || disabledPatient}
								></BaasicButton>
								<span className="u-flex--grow--1 type--sml type--wgt--bold u-mar--left--tny">{facilityOrderPatient.note}</span>
								<div className="u-align--h--right message">
									{
										facilityOrderPatient.effectiveDate &&
										<div>Effective Date: {facilityOrderPatient.effectiveDate ? toDate(facilityOrderPatient.effectiveDate) : ""}</div>
									}
									<BaasicButton
										className="btn btn--icon"
										icon="u-icon u-icon--clock u-icon--sml u-mar--left--xtny"
										label=""
										onlyIcon={true}
										onClick={() => openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal()}
										disabled={disabledPatient}
									></BaasicButton>
								</div>
							</div>
						}
					</div>

					<div className="card--tertiary__body" style={{ cursor: "pointer", paddingTop: "0" }} onClick={() => { changeOrderVisibility() }}>
						<div className="u-flex u-flex--default" >
							<span className="type--color--opaque"> {isOrderVisible ? "Hide Orders" : "See Orders"}</span>
							<i className={"u-icon u-icon--xsml " + (isOrderVisible ? "u-icon--arrow-up" : "u-icon--arrow-down") + " u-mar--left--sml"} />
						</div>
						{isOrderVisible && items.map(item => {
							return (<FacilityOrderTemplateTable key={item.id} facilityOrderTemplate={item} />);
						})}
					</div>

					<BaasicModal modalParams={facilityOrderTemplateNewFlowInsuranceProductModal} className="modal__content modal--xlrg">
						<FacilityOrderTemplateNewFlowInsuranceProductModal />
					</BaasicModal>

					<BaasicModal modalParams={facilityOrderTemplateItemNewFlowActivatePatientModal} className="modal__content modal--med">
						<FacilityOrderTemplateItemNewFlowActivatePatientModal />
					</BaasicModal>

					<BaasicModal modalParams={facilityOrderPatientNewFlowInsuranceNoteModal} className="modal__content modal--med">
						<FacilityOrderPatientNewFlowInsuranceNoteModal />
					</BaasicModal>

					<BaasicModal modalParams={facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal} className="modal__content modal--xxlrg">
						<FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal />
					</BaasicModal>

					<BaasicModal modalParams={facilityOrderPatientNewFlowInsuranceEditModal} className="modal__content modal--med">
						<FacilityOrderPatientNewFlowInsuranceEditModal />
					</BaasicModal>
				</Content>
			</div>
			: <React.Fragment></React.Fragment>
	);
};

const FacilityOrderTemplateTable = observer(({ facilityOrderTemplate }) => {

	return (
		<div className="table--secondary__wrapper u-mar--top--med u-mar--bottom--sml--alt is-add-new-disabled">
			<table width="100%" className="table--secondary">
				<colgroup>
					<col width="250*" />
					<col width="250*" />
					<col width="250*" />
				</colgroup>
				<thead>
					<tr>
						<th colSpan={"3"}>
							<div className="u-flex--space-between">
								<label>{facilityOrderTemplate.subCategory.name.toUpperCase()}</label>
								<div className="status--sqare__wrapper">
									{facilityOrderTemplate.isPriorAuthNeeded && <div className="label--fakebutton">PAR Required</div>}
									{!facilityOrderTemplate.templateId &&
										<div className="status--sqare__wrapper u-mar--left--xtny">
											<Button className="btn btn--base btn--light is-user is-template" />
										</div>
									}
								</div>
							</div>
							{facilityOrderTemplate.portalNote && facilityOrderTemplate.newFlowStatus &&
								<div className={`message message--med ${facilityOrderTemplate.newFlowStatus.abrv === "discharge" ? "message--note message--note--discontinued" : facilityOrderTemplate.newFlowStatus.abrv === "new-order" ? "message--primary" : "message--note"} u-mar--top--tny`}>
									<i className="u-icon u-icon--note--alt u-icon--sml u-mar--left--xtny" />
									{facilityOrderTemplate.portalNote}
								</div>
							}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td><span className="type--sml type--wgt--bold type--color--primary">ITEM NAME</span></td>
						<td><span className="type--sml type--wgt--bold type--color--primary">ITEM ID</span></td>
						<td><span className="type--sml type--wgt--bold type--color--primary">PROCEDURE CODE</span></td>
					</tr>
					{facilityOrderTemplate.facilityOrderTemplateItems.map((item) => {
						return (
							<tr key={item.id} >
								<td>
									{item.product && item.product.description}
								</td>
								<td>
									{item.product && item.product.itemId}
								</td>
								<td>
									{item.product && item.product.procedureCode}
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
});

FacilityOrderTemplateNewFlowInsuranceEditTemplate.propTypes = {
	facilityOrderTemplateNewFlowInsuranceEditViewStore: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	disabledSendOrder: PropTypes.bool
};

FacilityOrderTemplateTable.propTypes = {
	facilityOrderTemplate: PropTypes.object.isRequired
};

export default defaultTemplate(FacilityOrderTemplateNewFlowInsuranceEditTemplate);